import * as React from 'react';
import { bindActionCreators } from 'redux';
import { useDispatch, useSelector } from 'react-redux';

import { ChoseDealType } from '../../../../components/Recommendations';
import { DEMAND_DEAL_TYPES } from '../../constants';
import { selectDemandRequest } from '../../../../selectors/dataPayment';
import { setDemandRequestDealType } from '../../../../actions/dataPayment';

export interface IChoseDealTypeContainerProps {
  submitText: string;

  onSubmit(value: string): void;
}

export const ChoseDealTypeContainer: React.FC<IChoseDealTypeContainerProps> = ({ onSubmit, submitText }) => {
  const { dealType } = useSelector(selectDemandRequest);
  const dispatch = useDispatch();
  const boundActions = React.useMemo(
    () =>
      bindActionCreators(
        {
          setDemandRequestDealType,
        },
        dispatch,
      ),
    [dispatch],
  );

  return (
    <ChoseDealType
      options={DEMAND_DEAL_TYPES}
      onChange={boundActions.setDemandRequestDealType}
      selectedValue={dealType}
      submitText={submitText}
      onSubmit={onSubmit}
    />
  );
};

ChoseDealTypeContainer.displayName = 'ChoseDealTypeContainer';
